import { useSessionStorage } from "@uidotdev/usehooks";
import moment from "moment";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/Endpoint";
import { IFilterMerchant } from "../../types/interface";
import { hasValues } from "../../utils/hasValues";
import Card from "../Reusable/Card";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import InvoiceFilter from "./InvoiceFilter";
import { getKey } from "../../helpers/sessionKey";
import TabPanel from "../Reusable/Tab";

const MerchantInvoice = () => {
  const [localState, handleSetState] = useSessionStorage<IFilterMerchant>(
    "merchant-invoice-filter",
    {
      created__range: null,
      vendor: null,
      status__in: null,
      user: null,
    }
  );
  const [isFilterVisible, setFilterVisiable] = useState(hasValues(localState));
  const { setValue, getValues, watch, reset, control } =
    useForm<IFilterMerchant>({
      defaultValues: async () => ({
        created__range: localState?.created__range ?? null,
        vendor: localState?.vendor ?? null,
        status__in: localState?.status__in ?? null,
        user: localState?.user ?? null,
      }),
    });
  const clientType = getKey("client-type");

  const handleFilterReset = () => {
    reset({
      created__range: null,
      vendor: null,
      status__in: null,
      user: null,
    });
  };
  const defaultColumns: any = useMemo(() => {
    return [
      {
        header: "Statement ID",
        accessorKey: "invoice_id",
        cell: ({ row, getValue }: any) => {
          return (
            <div>
              <Link
                className={tw`cursor-pointer whitespace-nowrap focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`}
                to={`preview/${row?.original?.id}`}
              >
                {getValue() ?? "N/A"}
              </Link>
            </div>
          );
        },
      },
      {
        header: "Date Range",
        accessorKey: "date_range",
        cell: ({ getValue }: any) => {
          const value = getValue();
          if (!value) return <p className={tw`whitespace-nowrap`}>N/A</p>;

          try {
            const parsed = JSON.parse(value);
            const from = parsed?.lower
              ? moment(parsed.lower).format("YYYY-MM-DD")
              : "N/A";
            const to = parsed?.upper
              ? moment(parsed.upper).format("YYYY-MM-DD")
              : "N/A";

            return (
              <p className={tw`whitespace-nowrap`}>
                {from}
                <span className={tw`mx-1`}>-</span>
                {to}
              </p>
            );
          } catch (e) {
            return <p className={tw`whitespace-nowrap`}>N/A</p>;
          }
        },
      },
      {
        header: "Vendor Name",
        accessorKey: "user.full_name",
        cell: NACell,
      },
      {
        header: "Col. COD",
        accessorKey: "delivery_charge.collected",
        cell: ({ getValue }: any) => {
          return (
            <>
              <p className={tw`whitespace-nowrap`}>{getValue() ?? 0.0}</p>
            </>
          );
        },
      },
      {
        header: "D. Charge",
        accessorKey: "delivery_charge.charge",
        cell: ({ getValue }: any) => {
          return (
            <>
              <p className={tw`whitespace-nowrap`}>{getValue() ?? 0.0}</p>
            </>
          );
        },
      },
      {
        header: "Tax",
        accessorKey: "tax",
        cell: ({ getValue }: any) => {
          return (
            <>
              <p className={tw`whitespace-nowrap`}>{getValue() ?? 0.0}</p>
            </>
          );
        },
      },
      {
        header: "Amount",
        accessorKey: "invoice_amount",
        cell: ({ getValue }: any) => {
          return (
            <>
              <p className={tw`whitespace-nowrap`}>{getValue() ?? 0.0}</p>
            </>
          );
        },
      },
      {
        header: "Paid Date",
        accessorKey: "settlement_date",
        cell: ({ cell: { getValue } }) => {
          const value = getValue();
          if (!value) return <p>N/A</p>;

          const date = moment(value).format("YY-MM-DD");
          const time = moment(value).format("HH:mm:ss");

          return (
            <div className={tw`flex flex-col`}>
              <span className={tw`whitespace-nowrap`}>{date}</span>
              <span>{time}</span>
            </div>
          );
        },
      },
      {
        header: "Payment Remarks",
        accessorKey: "remarks",
        cell: NACell,
      },
      {
        header: "Status",
        accessorKey: "status",
        cell: ({ getValue }: any) => {
          return (
            <>
              <p className={tw`whitespace-nowrap uppercase`}>{getValue()}</p>
            </>
          );
        },
      },
    ];
  }, []);
  const reportColumns: any = useMemo(() => {
    return [
      {
        header: "Vendor Name",
        accessorKey: "user.full_name",
        cell: NACell,
      },
      {
        header: "Short Code",
        accessorKey: "short_code",
        cell: NACell,
      },
      {
        header: "Mobile Number",
        accessorKey: "user.mobile_number",
        cell: NACell,
      },
      // {
      //   header: "Email",
      //   accessorKey: "user.email",
      //   cell: NACell,
      // },
      {
        header: "Invoice Raised Amount",
        accessorKey: "invoice_raised_amount",
        cell: NACell,
      },
      {
        header: "Outstanding Amount",
        accessorKey: "outstanding_amount",
        cell: NACell,
      },
    ];
  }, []);

  const defaultCargoColumns: any = useMemo(() => {
    return [
      {
        header: "Statement ID",
        accessorKey: "invoice_id",
        cell: ({ row, getValue }: any) => {
          return (
            <div>
              <Link
                className={tw`cursor-pointer whitespace-nowrap focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`}
                to={`cargo-preview/${row?.original?.id}`}
              >
                {getValue() ?? "N/A"}
              </Link>
            </div>
          );
        },
      },
      {
        header: "Date Range",
        accessorKey: "date_range",
        cell: ({ getValue }: any) => {
          const value = getValue();
          if (!value) return <p className={tw`whitespace-nowrap`}>N/A</p>;

          try {
            const parsed = JSON.parse(value);
            const from = parsed?.lower
              ? moment(parsed.lower).format("YYYY-MM-DD")
              : "N/A";
            const to = parsed?.upper
              ? moment(parsed.upper).format("YYYY-MM-DD")
              : "N/A";

            return (
              <p className={tw`whitespace-nowrap`}>
                {from}
                <span className={tw`mx-1`}>-</span>
                {to}
              </p>
            );
          } catch (e) {
            return <p className={tw`whitespace-nowrap`}>N/A</p>;
          }
        },
      },
      {
        header: "Vendor Name",
        accessorKey: "user.full_name",
        cell: NACell,
      },
      {
        header: "Tax Amount",
        accessorKey: "tax",
        cell: ({ getValue }: any) => {
          return (
            <>
              <p className={tw`whitespace-nowrap`}>{getValue() ?? 0.0}</p>
            </>
          );
        },
      },
      {
        header: "Amount",
        accessorKey: "invoice_amount",
        cell: ({ getValue }: any) => {
          return (
            <>
              <p className={tw`whitespace-nowrap`}>{getValue() ?? 0.0}</p>
            </>
          );
        },
      },
      {
        header: "Paid Date",
        accessorKey: "settlement_date",
        cell: ({ getValue }: any) => {
          return (
            <p className={tw`text-sm whitespace-nowrap`}>
              {getValue()
                ? moment(getValue()).format("YY-MM-DD HH:mm:ss")
                : "N/A"}
            </p>
          );
        },
      },
      {
        header: "Payment Remarks",
        accessorKey: "remarks",
        cell: NACell,
      },
      {
        header: "Status",
        accessorKey: "status",
        cell: ({ getValue }: any) => {
          return (
            <>
              <p className={tw`whitespace-nowrap uppercase`}>{getValue()}</p>
            </>
          );
        },
      },
    ];
  }, []);

  const filterParams = watch();

  useEffect(() => {
    const newState = {
      ...localState,
      ...filterParams,
      status__in:
        filterParams?.status__in?.map((status) => ({
          ...status,
          id: status.value,
          name: status.label,
        })) || null,
      user:
        filterParams?.vendor?.user?.id ?? filterParams?.vendor?.user ?? null,
    };

    const isStateChanged =
      JSON.stringify(localState) !== JSON.stringify(newState);
    if (isStateChanged) {
      handleSetState(newState);
    }

    const currentValue =
      filterParams?.vendor?.user?.id ?? filterParams?.vendor?.user ?? null;
    if (getValues("user") !== currentValue) {
      setValue("user", currentValue);
    }
  }, [filterParams, setValue, localState, getValues]);

  const params = useCallback(() => {
    const newValue = {};
    for (const [key, value] of Object.entries(filterParams)) {
      if (value) {
        if (Array.isArray(value)) {
          newValue[key] = value.map((v) => v.value).join(",");
        } else if (typeof value === "object") {
          newValue[key] = value.id;
        } else if (!value) {
          newValue[key] = null;
        } else {
          newValue[key] = value;
        }
      }
    }
    return newValue;
  }, [filterParams]);

  return (
    <>
      <Card title="Filters" onClick={() => setFilterVisiable(!isFilterVisible)}>
        <InvoiceFilter
          isFilterVisible={isFilterVisible}
          setValue={setValue}
          getValues={getValues}
          handleFilterReset={handleFilterReset}
          control={control}
        />
      </Card>
      {/* {clientType === "cargo" ? ( */}
      <TabPanel
        tabTitle={["Merchant Invoice", "Merchant Report"]}
        tabPanels={[
          <DataTable
            url={APIS.MERCHANT_INVOICE}
            queryKey={"Merchant Invoice"}
            columns={
              clientType === "cargo" ? defaultCargoColumns : defaultColumns
            }
            addNewPagePath={"/Create"}
            tableName={"merchant-invoice"}
            orderSearch={true}
            params={params()}
          />,

          <DataTable
            url={APIS.MERCHANT_INVOICE_REPORT}
            queryKey={"vendor-report"}
            columns={reportColumns}
            // addNewPagePath={"/Create"}
            tableName={"merchant-report"}
            orderSearch={false}
            params={params()}
          />,
        ]}
      />
      {/* ) : ( */}
      {/* <DataTable
          url={APIS.MERCHANT_INVOICE}
          queryKey={"Merchant Invoice"}
          columns={
            clientType === "cargo" ? defaultCargoColumns : defaultColumns
          }
          addNewPagePath={"/Create"}
          tableName={"merchant-invoice"}
          orderSearch={true}
          params={params()}
        /> */}
      {/* )} */}
    </>
  );
};

export default MerchantInvoice;
